"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HlAccommodationDescriptionDataModel = exports.HlAccommodationRentModel = exports.HlAccommodationLocationModel = exports.HlAccommodationAmenitiesModel = exports.HlAccommodationQualityModel = exports.HlAccommodationCapacityModel = exports.HlAccommodationBeddingModel = exports.HlAccommodationAccessesModel = exports.HlAccommodationAccessDetailsModel = void 0;
const validator_1 = require("@leavy/validator");
const Currency_1 = require("../../money/domain/Currency");
const AccommodationQuality_1 = require("../domain/description/AccommodationQuality");
const Address_1 = require("../../common/model/Address");
const AccommodationCapacity_1 = require("../domain/description/AccommodationCapacity");
class HlAccommodationAccessDetailsModel {
    get _notes() {
        return this.notes;
    }
}
__decorate([
    (0, validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], HlAccommodationAccessDetailsModel.prototype, "isPresent", void 0);
__decorate([
    (0, validator_1.IsOptional)(),
    (0, validator_1.IsString)(),
    __metadata("design:type", String)
], HlAccommodationAccessDetailsModel.prototype, "notes", void 0);
__decorate([
    (0, validator_1.ValidateIf)((x) => x.isPresent),
    (0, validator_1.IsString)(),
    (0, validator_1.IsNotEmpty)(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HlAccommodationAccessDetailsModel.prototype, "_notes", null);
exports.HlAccommodationAccessDetailsModel = HlAccommodationAccessDetailsModel;
class HlAccommodationAccessesModel {
}
__decorate([
    (0, validator_1.Type)(() => HlAccommodationAccessDetailsModel),
    (0, validator_1.IsDefined)(),
    (0, validator_1.ValidateNested)(),
    __metadata("design:type", HlAccommodationAccessDetailsModel)
], HlAccommodationAccessesModel.prototype, "trash", void 0);
__decorate([
    (0, validator_1.Type)(() => HlAccommodationAccessDetailsModel),
    (0, validator_1.IsDefined)(),
    (0, validator_1.ValidateNested)(),
    __metadata("design:type", HlAccommodationAccessDetailsModel)
], HlAccommodationAccessesModel.prototype, "gas", void 0);
__decorate([
    (0, validator_1.Type)(() => HlAccommodationAccessDetailsModel),
    (0, validator_1.IsDefined)(),
    (0, validator_1.ValidateNested)(),
    __metadata("design:type", HlAccommodationAccessDetailsModel)
], HlAccommodationAccessesModel.prototype, "circuitBreaker", void 0);
__decorate([
    (0, validator_1.Type)(() => HlAccommodationAccessDetailsModel),
    (0, validator_1.IsDefined)(),
    (0, validator_1.ValidateNested)(),
    __metadata("design:type", HlAccommodationAccessDetailsModel)
], HlAccommodationAccessesModel.prototype, "waterMeter", void 0);
__decorate([
    (0, validator_1.Type)(() => HlAccommodationAccessDetailsModel),
    (0, validator_1.IsDefined)(),
    (0, validator_1.ValidateNested)(),
    __metadata("design:type", HlAccommodationAccessDetailsModel)
], HlAccommodationAccessesModel.prototype, "wifi", void 0);
exports.HlAccommodationAccessesModel = HlAccommodationAccessesModel;
class HlAccommodationBeddingModel {
}
__decorate([
    (0, validator_1.IsNumber)(),
    (0, validator_1.Min)(0),
    __metadata("design:type", Number)
], HlAccommodationBeddingModel.prototype, "duvets", void 0);
__decorate([
    (0, validator_1.IsNumber)(),
    (0, validator_1.Min)(0),
    __metadata("design:type", Number)
], HlAccommodationBeddingModel.prototype, "duvetCovers", void 0);
__decorate([
    (0, validator_1.IsNumber)(),
    (0, validator_1.Min)(0),
    __metadata("design:type", Number)
], HlAccommodationBeddingModel.prototype, "pillows", void 0);
__decorate([
    (0, validator_1.IsNumber)(),
    (0, validator_1.Min)(0),
    __metadata("design:type", Number)
], HlAccommodationBeddingModel.prototype, "pillowCases", void 0);
__decorate([
    (0, validator_1.IsNumber)(),
    (0, validator_1.Min)(0),
    __metadata("design:type", Number)
], HlAccommodationBeddingModel.prototype, "bedSheets", void 0);
__decorate([
    (0, validator_1.IsNumber)(),
    (0, validator_1.Min)(0),
    __metadata("design:type", Number)
], HlAccommodationBeddingModel.prototype, "towels", void 0);
exports.HlAccommodationBeddingModel = HlAccommodationBeddingModel;
class HlAccommodationCapacityModel {
    get beds() {
        return (this.simpleBeds +
            this.doubleBeds +
            this.sofaBeds);
    }
    get maxOccupancy() {
        return ((this.simpleBeds * AccommodationCapacity_1.AccommodationCapacity.SIMPLE_BED_HOSTING_CAPACITY) +
            (this.doubleBeds * AccommodationCapacity_1.AccommodationCapacity.DOUBLE_BED_HOSTING_CAPACITY) +
            (this.sofaBeds * AccommodationCapacity_1.AccommodationCapacity.SOFA_BED_HOSTING_CAPACITY));
    }
}
__decorate([
    (0, validator_1.IsNumber)(),
    (0, validator_1.Min)(1),
    __metadata("design:type", Number)
], HlAccommodationCapacityModel.prototype, "surfaceArea", void 0);
__decorate([
    (0, validator_1.IsNumber)(),
    (0, validator_1.Min)(0),
    __metadata("design:type", Number)
], HlAccommodationCapacityModel.prototype, "bedrooms", void 0);
__decorate([
    (0, validator_1.IsNumber)(),
    (0, validator_1.Min)(0),
    __metadata("design:type", Number)
], HlAccommodationCapacityModel.prototype, "bathrooms", void 0);
__decorate([
    (0, validator_1.IsNumber)(),
    (0, validator_1.Min)(0),
    __metadata("design:type", Number)
], HlAccommodationCapacityModel.prototype, "simpleBeds", void 0);
__decorate([
    (0, validator_1.IsNumber)(),
    (0, validator_1.Min)(0),
    __metadata("design:type", Number)
], HlAccommodationCapacityModel.prototype, "doubleBeds", void 0);
__decorate([
    (0, validator_1.IsNumber)(),
    (0, validator_1.Min)(0),
    __metadata("design:type", Number)
], HlAccommodationCapacityModel.prototype, "sofaBeds", void 0);
__decorate([
    (0, validator_1.IsNumber)(),
    (0, validator_1.Min)(1),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HlAccommodationCapacityModel.prototype, "beds", null);
__decorate([
    (0, validator_1.IsNumber)(),
    (0, validator_1.Min)(1),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HlAccommodationCapacityModel.prototype, "maxOccupancy", null);
exports.HlAccommodationCapacityModel = HlAccommodationCapacityModel;
class HlAccommodationQualityModel {
}
__decorate([
    (0, validator_1.IsEnum)(AccommodationQuality_1.AccommodationStanding),
    __metadata("design:type", String)
], HlAccommodationQualityModel.prototype, "standing", void 0);
__decorate([
    (0, validator_1.IsNumber)(),
    (0, validator_1.Min)(1),
    (0, validator_1.Max)(5),
    __metadata("design:type", Number)
], HlAccommodationQualityModel.prototype, "luminosity", void 0);
__decorate([
    (0, validator_1.IsNumber)(),
    (0, validator_1.Min)(1),
    (0, validator_1.Max)(5),
    __metadata("design:type", Number)
], HlAccommodationQualityModel.prototype, "furnishings", void 0);
__decorate([
    (0, validator_1.IsNumber)(),
    (0, validator_1.Min)(1),
    (0, validator_1.Max)(5),
    __metadata("design:type", Number)
], HlAccommodationQualityModel.prototype, "bedding", void 0);
__decorate([
    (0, validator_1.IsNumber)(),
    (0, validator_1.Min)(1),
    (0, validator_1.Max)(5),
    __metadata("design:type", Number)
], HlAccommodationQualityModel.prototype, "bathrooms", void 0);
exports.HlAccommodationQualityModel = HlAccommodationQualityModel;
class HlAccommodationAmenitiesModel {
}
__decorate([
    (0, validator_1.IsArray)(),
    (0, validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], HlAccommodationAmenitiesModel.prototype, "selected", void 0);
exports.HlAccommodationAmenitiesModel = HlAccommodationAmenitiesModel;
class HlAccommodationLocationModel {
}
__decorate([
    (0, validator_1.Type)(() => Address_1.AddressModel),
    (0, validator_1.IsDefined)(),
    (0, validator_1.ValidateNested)(),
    __metadata("design:type", Address_1.AddressModel)
], HlAccommodationLocationModel.prototype, "address", void 0);
__decorate([
    (0, validator_1.IsNumber)(),
    (0, validator_1.IsInt)(),
    __metadata("design:type", Number)
], HlAccommodationLocationModel.prototype, "floor", void 0);
__decorate([
    (0, validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], HlAccommodationLocationModel.prototype, "elevator", void 0);
exports.HlAccommodationLocationModel = HlAccommodationLocationModel;
class HlAccommodationRentModel {
}
__decorate([
    (0, validator_1.IsNumber)(),
    (0, validator_1.Min)(0),
    __metadata("design:type", Number)
], HlAccommodationRentModel.prototype, "value", void 0);
__decorate([
    (0, validator_1.IsEnum)(Currency_1.Currency),
    __metadata("design:type", String)
], HlAccommodationRentModel.prototype, "currency", void 0);
exports.HlAccommodationRentModel = HlAccommodationRentModel;
class HlAccommodationDescriptionDataModel {
}
__decorate([
    (0, validator_1.Type)(() => HlAccommodationRentModel),
    (0, validator_1.IsOptional)(),
    (0, validator_1.ValidateNested)(),
    __metadata("design:type", HlAccommodationRentModel)
], HlAccommodationDescriptionDataModel.prototype, "rent", void 0);
__decorate([
    (0, validator_1.Type)(() => HlAccommodationLocationModel),
    (0, validator_1.IsOptional)(),
    (0, validator_1.ValidateNested)(),
    __metadata("design:type", HlAccommodationLocationModel)
], HlAccommodationDescriptionDataModel.prototype, "location", void 0);
__decorate([
    (0, validator_1.Type)(() => HlAccommodationAmenitiesModel),
    (0, validator_1.IsOptional)(),
    (0, validator_1.ValidateNested)(),
    __metadata("design:type", HlAccommodationAmenitiesModel)
], HlAccommodationDescriptionDataModel.prototype, "amenities", void 0);
__decorate([
    (0, validator_1.Type)(() => HlAccommodationQualityModel),
    (0, validator_1.IsOptional)(),
    (0, validator_1.ValidateNested)(),
    __metadata("design:type", HlAccommodationQualityModel)
], HlAccommodationDescriptionDataModel.prototype, "quality", void 0);
__decorate([
    (0, validator_1.Type)(() => HlAccommodationCapacityModel),
    (0, validator_1.IsOptional)(),
    (0, validator_1.ValidateNested)(),
    __metadata("design:type", HlAccommodationCapacityModel)
], HlAccommodationDescriptionDataModel.prototype, "capacity", void 0);
__decorate([
    (0, validator_1.Type)(() => HlAccommodationBeddingModel),
    (0, validator_1.IsOptional)(),
    (0, validator_1.ValidateNested)(),
    __metadata("design:type", HlAccommodationBeddingModel)
], HlAccommodationDescriptionDataModel.prototype, "bedding", void 0);
__decorate([
    (0, validator_1.Type)(() => HlAccommodationAccessesModel),
    (0, validator_1.IsOptional)(),
    (0, validator_1.ValidateNested)(),
    __metadata("design:type", HlAccommodationAccessesModel)
], HlAccommodationDescriptionDataModel.prototype, "accesses", void 0);
exports.HlAccommodationDescriptionDataModel = HlAccommodationDescriptionDataModel;
//# sourceMappingURL=HlAccommodationDescriptionData.js.map